module.exports = __webpack_public_path__ + "img/10.a02b5e7c.jpg";